import Vue from "vue";
import common from './common'
import vant from './vant'

Vue.use(common)
Vue.use(vant)


// WEBPACK FOOTER //
// src/plugin/index.js